// extracted by mini-css-extract-plugin
module.exports = {"grid":"Visit_grid__23GM3","content":"Visit_content__11PNY"};